var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',[_vm._v("Select...")]),_vm._v(" "),_vm._l((_vm.forms),function(form,idx){return _c('option',{key:`form-${idx}`,domProps:{"value":form.id,"selected":_vm.selected == form.id}},[_vm._v(_vm._s(form.name))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }